import { SVGProps } from 'react';

export const ProactiveClientOutreach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.0002 4.95994L16.3164 1.23828V24.8088H18.7975V7.61844L25.0002 4.95994Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92424 3.72166C9.92424 1.66978 8.25446 0 6.2026 0C4.15073 0 2.48096 1.66978 2.48096 3.72166C2.48096 5.77353 4.15073 7.44332 6.2026 7.44332C8.25446 7.44332 9.92424 5.77353 9.92424 3.72166"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.20273 7.44336C2.78255 7.44336 0 10.2259 0 13.6461V17.3678C0 18.0526 0.555765 18.6083 1.24055 18.6083H2.48109V23.5705C2.48109 24.2553 3.03686 24.8111 3.72164 24.8111H8.68383C9.36861 24.8111 9.92437 24.2553 9.92437 23.5705V18.6083H11.1649C11.8497 18.6083 12.4055 18.0526 12.4055 17.3678V13.6461C12.4055 10.2259 9.62292 7.44336 6.20273 7.44336"
      fill="currentColor"
    />
  </svg>
);
